export const createFormatter = (locale = 'es-MX', currency = 'MXN') =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  });
